
import { iInputCellProps } from "./common";
import { TableCell ,Tooltip} from "@mui/material";
import { useDropzone } from "react-dropzone";
import { useCallback } from "react";
import {  getLanguage, useTranslation } from "react-multi-lang";
import { msgs } from "../../services/Validation/msgs";





export function InputWindow (props:iInputCellProps) {
 const t = useTranslation()
   const today = new Date().toISOString().split("T")[0];
       const allowed = ["image/jpeg", "image/png", "application/pdf"];

  const onDrop = useCallback((acceptedFiles:File [],e:any) => {

     let  file = acceptedFiles[0]
      if (file && props.setFieldValue) {

        let input_ = inputRef.current as HTMLInputElement 
        const matches = [...input_.name.matchAll(/\[(\w+)\]/g)];
  
        const values = matches.map(m => m[1]);
        let [index,input_name]=values
    
        
        if (input_name ==='invoice_copy') {

           props.setFieldValue(`[${index}][invoice_copy_file]`,file,false)
          props.setFieldValue(input_.name,file.name,false)
       
              if (props.deleteFieldError)props.deleteFieldError(`[${index}][invoice_copy_file]`,file)
          
            }
          
         
        
        
  
      }
     }
     , [])

  const {getRootProps, getInputProps , isDragActive,inputRef } = useDropzone({onDrop})

    return (
       <Tooltip
        
                                  title={props.not_valid ?
                                    props.msg_err : ''
                                  }
                                  slotProps={{
                                    tooltip: {
                                      sx: {
        
                                        background: 'white',
                                        color: 'red',
                                        border: '1px solid red'
                                      }
                                    }
                                  }}
        
                                  key={props.index}
        
                                >
               <div key={props.index}
               style ={{
                              borderColor: 'lightgray',
                                      borderLeft: '1px dashed  lightgray',
                                      borderLeftStyle: 'dashed',
                                      padding: '0px',
                                      verticalAlign: 'center',
                                      border:
                                        props.not_valid ?
                                          "1px solid red"
        
                                          : '',
                                      width:'100%',
                                      maxWidth:'100%' 
               }}
                { ...(props.type === 'file' && props.enabled && getRootProps())}
                >
                                 
        
                                    {props.type === 'file' && !props.enabled ?
                                      <a href={props.value} target='_blank' style={{ 'textAlign': 'center' ,cursor:'pointer'}} >
                                        {t('show_image')}
                                      </a>
                                      :
                                      props.type ==='note' ? 
                                      <textarea 
                                       style={{
                                        resize:'none',
                                        maxWidth:'100%'
                                       }}
                                        disabled={!props.enabled}
                                        onKeyDown={props.handleKeyDown}
                                        className={`input tab_element  table_input ${props.not_valid ?
                                            "inValid"
        
                                            : ''
        
                                          }`}
                                        name={
                                         props.input_name
                                        }
                                    
                                        onBlur={props.handleBlur ? props.handleBlur as any : undefined}
                                        contentEditable={true}
                                        onChange={(e: React.ChangeEvent) =>{
                                
                                         props.handleChange&& props.handleChange(e, props.row_number??-1)
                                        }
                                        }
                                        value={ props.value}
                                      /> 
        
                                      
                                      : 
                                      <input
                                       
                                        type={
                                         props.type
        
                                        }
                                        style={{
                                          maxWidth:'100%'
                                        }}
                                        max={props.type === 'date' ? today : undefined }
                                        disabled={!props.enabled}
                                        onKeyDown={props.handleKeyDown}
                                        className={`input tab_element  table_input ${props.not_valid ?
                                            "inValid"
        
                                            : ''
        
                                          }`}
                                        name={
                                          props.input_name
                                        }
                                       
                                        onBlur={props.handleBlur ? props.handleBlur as any : undefined}
                                        contentEditable={true}
                                        onChange={(e: React.ChangeEvent) =>
                                            props.handleChange? props.handleChange(e, props.row_number??-1):undefined
                                        }
                                        value={props.type ==='file'?null: props.value}
                                        { ...(props.type === 'file' && getInputProps() ) }
                                      />
                                    }
                                      { props.type === 'file' && props.enabled &&  (
                                       
                                         
                                           isDragActive ?
                                           <p> 
                                            <i className='icon-plus' style={{color:'var(--primary-color)',margin:'0 5px'}}></i>
                                            {getLanguage()==='en'?'Drop the file here…':'ألقي الملف هنا'}

        
                                           </p>
                                          : 
                                            <span style={{cursor:'pointer'}} >{props.value  ? props.value :
                                              getLanguage()==='en'? 'Click to select a file or drag & drop it here':
                                              'اضغط أو اسحب الملف الى هنا'
                                              }</span>
                                      )
                                          
                                          }
                                          
                             
                                </div>
                                </Tooltip>
    )
}